import { makeAPICall } from "../../utils/common";
import config from "../../utils/config";

export const GET_ACTIVATION_DISTRIBUTION_API = "GET_ACTIVATION_DISTRIBUTION_API";
export const GET_ACTIVATION_DISTRIBUTION_API_SUCCESS = "GET_ACTIVATION_DISTRIBUTION_API_SUCCESS";
export const GET_ACTIVATION_DISTRIBUTION_API_FAILED = "GET_ACTIVATION_DISTRIBUTION_API_FAILED";
 
export const GET_ACTIVATION_DIST_CSV_API="GET_ACTIVATION_DIST_CSV_API";
export const GET_ACTIVATION_DIST_CSV_API_SUCCESS="GET_ACTIVATION_DIST_CSV_API_SUCCESS";
export const GET_ACTIVATION_DIST_CSV_API_FAILED="GET_ACTIVATION_DIST_CSV_API_FAILED";

export const GET_SIMBILLING_API = "GET_SIMBILLING_API"
export const GET_SIMBILLING_API_SUCCESS = "GET_SIMBILLING_API_SUCCESS"
export const GET_SIMBILLING_API_FAILED = "GET_SIMBILLING_API_FAILED"

export const GET_SIMBILLINGCSV_API = "GET_SIMBILLINGCSV_API"
export const GET_SIMBILLINGCSV_API_SUCCESS = "GET_SIMBILLINGCSV_API_SUCCESS"
export const GET_SIMBILLINGCSV_API_FAILED = "GET_SIMBILLINGCSV_API_FAILED"

export const GET_SIM_ACTIVATION_API = "GET_SIM_ACTIVATION_API";
export const GET_SIM_ACTIVATION_API_SUCCESS = "GET_SIM_ACTIVATION_API_SUCCESS";
export const GET_SIM_ACTIVATION_API_FAILED = "GET_SIM_ACTIVATION_API_FAILED";

export const GET_SIM_ACTIVATION_JIOPHONE_API = "GET_SIM_ACTIVATION_JIOPHONE_API";
export const GET_SIM_ACTIVATION_JIOPHONE_API_SUCCESS = "GET_SIM_ACTIVATION_JIOPHONE_API_SUCCESS";
export const GET_SIM_ACTIVATION_JIOPHONE_API_FAILED = "GET_SIM_ACTIVATION_JIOPHONE_API_FAILED";

export const GET_SIM_ACTIVATION_CSV_API = "GET_SIM_ACTIVATION_JIOPHONE_CSV_API";
export const GET_SIM_ACTIVATION_CSV_API_SUCCESS = "GET_SIM_ACTIVATION_JIOPHONE_CSV_API_SUCCESS";
export const GET_SIM_ACTIVATION_CSV_API_FAILED = "GET_SIM_ACTIVATION_JIOPHONE_CSV_API_FAILED";

export const GET_SIM_ACTIVATION_JIOPHONE_CSV_API = "GET_SIM_ACTIVATION_CSV_API";
export const GET_SIM_ACTIVATION_JIOPHONE_CSV_API_SUCCESS = "GET_SIM_ACTIVATION_CSV_API_SUCCESS";
export const GET_SIM_ACTIVATION_JIOPHONE_CSV_API_FAILED = "GET_SIM_ACTIVATION_CSV_API_FAILED";

export const GET_DAILY_ACTIVATING_OUTLET_API = "GET_DAILY_ACTIVATING_OUTLET_API";
export const GET_DAILY_ACTIVATING_OUTLET_API_SUCCESS = "GET_DAILY_ACTIVATING_OUTLET_API_SUCCESS";
export const GET_DAILY_ACTIVATING_OUTLET_API_FAILED = "GET_DAILY_ACTIVATING_OUTLET_API_FAILED";

export const GET_DAILY_ACTIVATING_OUTLET_CSV_API = "GET_DAILY_ACTIVATING_OUTLET_CSV_API";
export const GET_DAILY_ACTIVATING_OUTLET_CSV_API_SUCCESS = "GET_DAILY_ACTIVATING_OUTLET_CSV_API_SUCCESS";
export const GET_DAILY_ACTIVATING_OUTLET_CSV_API_FAILED = "GET_DAILY_ACTIVATING_OUTLET_CSV_API_FAILED";

export const GET_TOP_5_RETAILERS_API = "GET_TOP_5_RETAILERS_API";
export const GET_TOP_5_RETAILERS_API_SUCCESS = "GET_TOP_5_RETAILERS_API_SUCCESS";
export const GET_TOP_5_RETAILERS_API_FAILED = "GET_TOP_5_RETAILERS_API_FAILED";

export const GET_BOTTOM_5_RETAILERS_API = "GET_BOTTOM_5_RETAILERS_API";
export const GET_BOTTOM_5_RETAILERS_API_SUCCESS = "GET_BOTTOM_5_RETAILERS_API_SUCCESS";
export const GET_BOTTOM_5_RETAILERS_API_FAILED = "GET_BOTTOM_5_RETAILERS_API_FAILED";

export const GET_LAST_7_DAYS_API = "GET_LAST_7_DAYS_API";
export const GET_LAST_7_DAYS_API_SUCCESS = "GET_LAST_7_DAYS_API_SUCCESS";
export const GET_LAST_7_DAYS_API_FAILED = "GET_LAST_7_DAYS_API_FAILED";

export const GET_LAST_7_DAYS_CSV_API = "GET_LAST_7_DAYS_CSV_API";
export const GET_LAST_7_DAYS_CSV_API_SUCCESS = "GET_LAST_7_DAYS_CSV_API_SUCCESS";
export const GET_LAST_7_DAYS_CSV_API_FAILED = "GET_LAST_7_DAYS_CSV_API_FAILED";

export const GET_CAF_PENDENCY_API = "GET_CAF_PENDENCY_API";
export const GET_CAF_PENDENCY_API_SUCCESS = "GET_CAF_PENDENCY_API_SUCCESS";
export const GET_CAF_PENDENCY_API_FAILED = "GET_CAF_PENDENCY_API_FAILED";

export const GET_CAF_PENDENCY_CSV_API = "GET_CAF_PENDENCY_CSV_API";
export const GET_CAF_PENDENCY_CSV_API_SUCCESS = "GET_CAF_PENDENCY_CSV_API_SUCCESS";
export const GET_CAF_PENDENCY_CSV_API_FAILED = "GET_CAF_PENDENCY_CSV_API_FAILED";

export const SHOW_ALERT_ACTIVATION = "SHOW_ALERT_ACTIVATION";
export const HIDE_ALERT_ACTIVATION = "HIDE_ALERT_ACTIVATION";

export const GET_SIM_ACT_METRICS_API = "GET_SIM_ACT_METRICS_API";
export const GET_SIM_ACT_METRICS_API_SUCCESS = "GET_SIM_ACT_METRICS_API_SUCCESS";
export const GET_SIM_ACT_METRICS_API_FAILED = "GET_SIM_ACT_METRICS_API_FAILED";

export function fetchShowAlertActivation() {
    return {
        type: SHOW_ALERT_ACTIVATION,
    }
  }
  
  export function hideAlertActivation(){
    return {
        type: HIDE_ALERT_ACTIVATION
    }
  }

export function triggerFetchActivationDistributionTable(obj) {
    return dispatch => {
        const params = {
            url: `${config.apiBasePath.baseIp}activationDistribution`,
            dispatch,
            params: obj.params,
            headers: obj.headers,
            defaultAction: GET_ACTIVATION_DISTRIBUTION_API,
            successAction: GET_ACTIVATION_DISTRIBUTION_API_SUCCESS,
            failedAction: GET_ACTIVATION_DISTRIBUTION_API_FAILED,
            type: "POST",
            callback: obj.callback,
            extraData: obj.extraData
        }
        makeAPICall(params);
    }
}
export function triggerActivationDistributionCsv(obj,callback) {
    return dispatch => {
        const params = {
            url: `${config.apiBasePath.baseIp}activationDistributionCsv`,
            dispatch,
            params: obj.params,
            headers: obj.headers,
            defaultAction: GET_ACTIVATION_DIST_CSV_API,
            successAction: GET_ACTIVATION_DIST_CSV_API_SUCCESS,
            failedAction: GET_ACTIVATION_DIST_CSV_API_FAILED,
            type: "POST",
            callback: callback,
            extraData: obj.extraData,
            tab:obj.tab
        }
        //setTimeout(function(){ makeAPICall(params) }, 2000);
        makeAPICall(params);
    }
}

export function triggerFetchSimBilling(obj){
    return dispatch => {
        const params = {
            url: `${config.apiBasePath.baseIp}simBilling`,
            dispatch,
            params: obj.params,
            headers: obj.headers,
            defaultAction: GET_SIMBILLING_API,
            successAction: GET_SIMBILLING_API_SUCCESS,
            failedAction: GET_SIMBILLING_API_FAILED,
            type: "POST",
            callback: obj.callback,
            extraData: obj.extraData,
            tab:obj.tab
        }
        makeAPICall(params);
    }
}

export function triggerFetchSimBillingCsv(obj, callback){
    return dispatch => {
        const params = {
            url: `${config.apiBasePath.baseIp}simBillingCsv`,
            dispatch,
            params: obj.params,
            headers: obj.headers,
            defaultAction: GET_SIMBILLINGCSV_API,
            successAction: GET_SIMBILLINGCSV_API_SUCCESS,
            failedAction: GET_SIMBILLINGCSV_API_FAILED,
            type: "POST",
            callback: callback,
            extraData: obj.extraData,
            tab:obj.tab
        }
        makeAPICall(params);
    }
}

export function triggerSimActivationAPI(obj) {
    return dispatch => {
        const params = {
            url: `${config.apiBasePath.baseIp}simActivation`,
            dispatch,
            params: obj.params,
            headers: obj.headers,
            defaultAction: GET_SIM_ACTIVATION_API,
            successAction: GET_SIM_ACTIVATION_API_SUCCESS,
            failedAction: GET_SIM_ACTIVATION_API_FAILED,
            type: "POST",
            callback: obj.callback,
            extraData: obj.extraData
        }
        makeAPICall(params);
    }
}

export function triggerSimActivationCsvAPI(obj, callback) {
    return dispatch => {
        const params = {
            url: `${config.apiBasePath.baseIp}simActivationCsv`,
            dispatch,
            params: obj.params,
            headers: obj.headers,
            defaultAction: GET_SIM_ACTIVATION_CSV_API,
            successAction: GET_SIM_ACTIVATION_CSV_API_SUCCESS,
            failedAction: GET_SIM_ACTIVATION_CSV_API_FAILED,
            type: "POST",
            callback: callback,
            extraData: obj.extraData,
            tab:obj.tab
        }
        //setTimeout(function(){ makeAPICall(params) }, 100);
        makeAPICall(params);
    }
}
export function triggerSimActivationJiophoneAPI(obj) {
    return dispatch => {
        const params = {
            url: `${config.apiBasePath.baseIp}simActivation`,
            dispatch,
            params: obj.params,
            headers: obj.headers,
            defaultAction: GET_SIM_ACTIVATION_JIOPHONE_API,
            successAction: GET_SIM_ACTIVATION_JIOPHONE_API_SUCCESS,
            failedAction: GET_SIM_ACTIVATION_JIOPHONE_API_FAILED,
            type: "POST",
            callback: obj.callback,
            extraData: obj.extraData
        }
        makeAPICall(params);
    }
}

export function triggerSimActivationJiophoneCsvAPI(obj, callback) {
    return dispatch => {
        const params = {
            url: `${config.apiBasePath.baseIp}simActivationCsv`,
            dispatch,
            params: obj.params,
            headers: obj.headers,
            defaultAction: GET_SIM_ACTIVATION_JIOPHONE_CSV_API,
            successAction: GET_SIM_ACTIVATION_JIOPHONE_CSV_API_SUCCESS,
            failedAction: GET_SIM_ACTIVATION_JIOPHONE_CSV_API_FAILED,
            type: "POST",
            callback: callback,
            extraData: obj.extraData,
            tab:obj.tab
        }
        //setTimeout(function(){ makeAPICall(params) }, 100);
        makeAPICall(params);
    }
}
export function triggerDailyActivatingOutletAPI(obj) {
    return dispatch => {
        const params = {
            url: `${config.apiBasePath.baseIp}dailyActivatingOutlet`,
            dispatch,
            params: obj.params,
            headers: obj.headers,
            defaultAction: GET_DAILY_ACTIVATING_OUTLET_API,
            successAction: GET_DAILY_ACTIVATING_OUTLET_API_SUCCESS,
            failedAction: GET_DAILY_ACTIVATING_OUTLET_API_FAILED,
            type: "POST",
            callback: obj.callback,
            extraData: obj.extraData
        }
        //setTimeout(function(){ makeAPICall(params) }, 100);
        makeAPICall(params);
    }
}

export function triggerDailyActivatingOutletCsvAPI(obj, callback) {
    return dispatch => {
        const params = {
            url: `${config.apiBasePath.baseIp}dailyActivatingOutletCsv`,
            dispatch,
            params: obj.params,
            headers: obj.headers,
            defaultAction: GET_DAILY_ACTIVATING_OUTLET_CSV_API,
            successAction: GET_DAILY_ACTIVATING_OUTLET_CSV_API_SUCCESS,
            failedAction: GET_DAILY_ACTIVATING_OUTLET_CSV_API_FAILED,
            type: "POST",
            callback: callback,
            extraData: obj.extraData,
            tab:obj.tab
        }
        //setTimeout(function(){ makeAPICall(params) }, 100);
        makeAPICall(params);
    }
}

export function triggerTop5RetailersAPI(obj) {
    return dispatch => {
        const params = {
            url: `${config.apiBasePath.baseIp}top5Retailers`,
            dispatch,
            params: obj.params,
            headers: obj.headers,
            defaultAction: GET_TOP_5_RETAILERS_API,
            successAction: GET_TOP_5_RETAILERS_API_SUCCESS,
            failedAction: GET_TOP_5_RETAILERS_API_FAILED,
            type: "POST",
            callback: obj.callback,
            extraData: obj.extraData
        }
        //setTimeout(function(){ makeAPICall(params) }, 100);
        makeAPICall(params);
    }
}

export function triggerBottom5RetailersAPI(obj) {
    return dispatch => {
        const params = {
            url: `${config.apiBasePath.baseIp}bottom5Retailers`,
            dispatch,
            params: obj.params,
            headers: obj.headers,
            defaultAction: GET_BOTTOM_5_RETAILERS_API,
            successAction: GET_BOTTOM_5_RETAILERS_API_SUCCESS,
            failedAction: GET_BOTTOM_5_RETAILERS_API_FAILED,
            type: "POST",
            callback: obj.callback,
            extraData: obj.extraData
        }
        //setTimeout(function(){ makeAPICall(params) }, 100);
        makeAPICall(params);
    }
}

export function triggerLast7DaysAPI(obj,callback) {
    return dispatch => {
        const params = {
            url: `${config.apiBasePath.baseIp}last7Days`,
            dispatch,
            params: obj.params,
            headers: obj.headers,
            defaultAction: GET_LAST_7_DAYS_API,
            successAction: GET_LAST_7_DAYS_API_SUCCESS,
            failedAction: GET_LAST_7_DAYS_API_FAILED,
            type: "POST",
            callback: callback,
            extraData: obj.extraData
        }
        //setTimeout(function(){ makeAPICall(params) }, 100);
        makeAPICall(params);
    }
}

export function triggerLast7DaysCsvAPI(obj,callback) {
    return dispatch => {
        const params = {
            url: `${config.apiBasePath.baseIp}last7DaysCsv`,
            dispatch,
            params: obj.params,
            headers: obj.headers,
            defaultAction: GET_LAST_7_DAYS_CSV_API,
            successAction: GET_LAST_7_DAYS_CSV_API_SUCCESS,
            failedAction: GET_LAST_7_DAYS_CSV_API_FAILED,
            type: "POST",
            callback:callback,
            extraData: obj.extraData,
            tab:obj.tab
        }
        //setTimeout(function(){ makeAPICall(params) }, 100);
        makeAPICall(params);
    }
}

export function triggerCafPendencyAPI(obj) {
    return dispatch => {
        const params = {
            url: `${config.apiBasePath.baseIp}cafPendency`,
            dispatch,
            params: obj.params,
            headers: obj.headers,
            defaultAction: GET_CAF_PENDENCY_API,
            successAction: GET_CAF_PENDENCY_API_SUCCESS,
            failedAction: GET_CAF_PENDENCY_API_FAILED,
            type: "POST",
            callback: obj.callback,
            extraData: obj.extraData
        }
        //setTimeout(function(){ makeAPICall(params) }, 100);
        makeAPICall(params);
    }
}

export function triggerCafPendencyCsvAPI(obj,callback) {
    return dispatch => {
        const params = {
            url: `${config.apiBasePath.baseIp}cafPendencyCsv`,
            dispatch,
            params: obj.params,
            headers: obj.headers,
            defaultAction: GET_CAF_PENDENCY_CSV_API,
            successAction: GET_CAF_PENDENCY_CSV_API_SUCCESS,
            failedAction: GET_CAF_PENDENCY_CSV_API_FAILED,
            type: "POST",
            callback: callback,
            extraData: obj.extraData,
            tab:obj.tab
        }
        //setTimeout(function(){ makeAPICall(params) }, 500);
        makeAPICall(params);
    }
}

export function triggerFetchSimActMetricsAPI(obj) {
    return (dispatch) => {
        const params = {
            url: obj.url,
            dispatch,
            params: obj.params,
            headers: obj.headers,
            defaultAction: GET_SIM_ACT_METRICS_API,
            successAction: GET_SIM_ACT_METRICS_API_SUCCESS,
            failedAction: GET_SIM_ACT_METRICS_API_FAILED,
            type: "POST",
            extraData: obj.extraData,
        };
        makeAPICall(params);
    };
}